<template>
  <v-snackbar
      v-model="display"
      :color="color ? color : 'success'"
      :timeout="4000"
  >
    {{ displayMessage }}
  </v-snackbar>
</template>

<script>
export default {
    props: [
        'text',
        'color'
    ],
    data () {
        return {
            displayMessage: null,
            display: false
        }
    },
    methods: {
    },
    created () {
      this.display = this.value;
    },
    watch: {
      text: {
        handler: function(newValue) {
          if(newValue != ''){
            this.display = true;
            this.displayMessage = newValue;
          }else{
            this.display = false;
          }
        }
      }
    },
}
</script>

<style scoped>
</style>
